import axios from 'axios';

const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL || '',
    headers: {
        'Content-Type': 'application/json',
    },
});

axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
        // Seule une requête authentifiée peut signifier une session expirée ;
        // un 401 sans token (ex. identifiants erronés au login) est géré par l'appelant.
        const wasAuthenticated = Boolean(error.config?.headers?.Authorization);
        if (error.response && error.response.status === 401 && wasAuthenticated) {
            localStorage.removeItem('token');
            window.location.href = '/?message=' + encodeURIComponent('Vous avez été déconnecté');
        }
        return Promise.reject(error);
    }
);

export const apiService = {
    async get(endpoint, isReady, token) {
        if (!isReady || !token) {
            return Promise.reject(new Error('Authentication not ready'));
        }

        return axiosInstance.get(endpoint, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
    },

    async post(endpoint, data, isReady, token) {
        if (!isReady || !token) {
            return Promise.reject(new Error('Authentication not ready'));
        }

        return axiosInstance.post(endpoint, data, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
    },

    async put(endpoint, data, isReady, token) {
        if (!isReady || !token) {
            return Promise.reject(new Error('Authentication not ready'));
        }

        return axiosInstance.put(endpoint, data, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
    },

    async delete(endpoint, isReady, token) {
        if (!isReady || !token) {
            return Promise.reject(new Error('Authentication not ready'));
        }

        return axiosInstance.delete(endpoint, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
    },

    async getPublic(endpoint) {
        return axiosInstance.get(endpoint);
    }
};

export default axiosInstance;

